import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { findProjectionByProjectionId } from '@bo-utils/projection';

export function useBulkRankActions({
  newAndChangedProjections,
  setSimProjections,
  simProjections,
  updateProjection
}: {
  newAndChangedProjections: Array<GamePlayerProjectionTrading>;
  setSimProjections: (
    simsProjections: Array<GamePlayerProjectionTrading>
  ) => void;
  simProjections: Array<GamePlayerProjectionTrading>;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: GamePlayerProjectionTrading;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
}): {
  handleBulkRankChange: (rankChange: string) => void;
  handleReorderByRank: () => void;
} {
  const handleBulkRankChange = (rankChange: string) => {
    if (rankChange === '') {
      return;
    }

    simProjections.forEach((initialProjection, index) => {
      const projectionChanges = findProjectionByProjectionId({
        projectionArray: newAndChangedProjections,
        projectionId: initialProjection.projectionId
      });

      updateProjection({
        change: {
          ...initialProjection,
          ...projectionChanges,
          rank: Number(rankChange) + index
        },
        initialProjection
      });
    });
  };

  const handleReorderByRank = () => {
    const sortedProjections = simProjections.sort((a, b) => {
      const aProjectionChanges = findProjectionByProjectionId({
        projectionArray: newAndChangedProjections,
        projectionId: a.projectionId
      });

      const aProjectionWithChanges = { ...a, ...aProjectionChanges };

      const bProjectionChanges = findProjectionByProjectionId({
        projectionArray: newAndChangedProjections,
        projectionId: b.projectionId
      });

      const bProjectionWithChanges = { ...b, ...bProjectionChanges };

      const { rank: aRank } = aProjectionWithChanges;
      const { rank: bRank } = bProjectionWithChanges;

      return (aRank || 0) - (bRank || 0);
    });

    setSimProjections([...sortedProjections]);
  };

  return {
    handleBulkRankChange,
    handleReorderByRank
  };
}
